"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getPositionStyles = exports.AnchoredOverlay = void 0;

var tslib_1 = require("tslib");

var ui_helper_deep_branding_1 = require("@hopin-team/ui-helper-deep-branding");

var ui_helper_hooks_1 = require("@hopin-team/ui-helper-hooks");

var dialog_1 = require("@reach/dialog");

var window_size_1 = require("@reach/window-size");

var react_1 = tslib_1.__importStar(require("react"));

var styled_components_1 = tslib_1.__importDefault(require("styled-components"));

function getOverlayVerticalStyles(anchorRect, windowSize, verticalAlignment) {
  switch (verticalAlignment) {
    case 'below':
      return {
        top: anchorRect.top + anchorRect.height,
        bottom: 'initial'
      };

    case 'auto':
      return {
        top: anchorRect.top < windowSize.height / 2 ? anchorRect.top + anchorRect.height : 'initial',
        bottom: anchorRect.top > windowSize.height / 2 ? windowSize.height - anchorRect.top : 'initial'
      };

    case 'above':
      return {
        top: 'initial',
        bottom: windowSize.height - anchorRect.top
      };
  }
}

function getPositionStyles(anchor, overlayAlignment, windowSize, verticalAlignment) {
  if (!anchor) {
    return {};
  }

  var anchorRect = anchor.getBoundingClientRect();

  var _a = getOverlayVerticalStyles(anchorRect, windowSize, verticalAlignment),
      top = _a.top,
      bottom = _a.bottom;

  switch (overlayAlignment) {
    case 'left':
      return {
        position: 'absolute',
        top: top,
        bottom: bottom,
        left: anchorRect.left
      };

    case 'center':
      return {
        position: 'absolute',
        top: top,
        bottom: bottom,
        left: anchorRect.left + anchorRect.width / 2,
        transform: "translateX(-50%)"
      };

    case 'right':
      return {
        position: 'absolute',
        top: top,
        bottom: bottom,
        right: windowSize.width - anchorRect.right
      };
  }
}

exports.getPositionStyles = getPositionStyles;
var StyledDialogOverlay = (0, styled_components_1.default)(dialog_1.DialogOverlay)(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n  background: transparent;\n"], ["\n  background: transparent;\n"])));
var StyledDialogContent = (0, styled_components_1.default)(dialog_1.DialogContent)(templateObject_2 || (templateObject_2 = tslib_1.__makeTemplateObject(["\n  background-color: transparent;\n  width: auto;\n  margin: 0;\n  padding: 0;\n"], ["\n  background-color: transparent;\n  width: auto;\n  margin: 0;\n  padding: 0;\n"])));

function AnchoredOverlay(_a) {
  var __UIScope = _a.__UIScope,
      onDismiss = _a.onDismiss,
      _b = _a.isDismissible,
      isDismissible = _b === void 0 ? true : _b,
      isOpen = _a.isOpen,
      children = _a.children,
      anchorRef = _a.anchorRef,
      initialFocusRef = _a.initialFocusRef,
      _c = _a.overlayAlignment,
      overlayAlignment = _c === void 0 ? 'center' : _c,
      _d = _a.verticalAlignment,
      verticalAlignment = _d === void 0 ? 'below' : _d,
      className = _a.overlayClassName,
      contentClassName = _a.contentClassName,
      props = tslib_1.__rest(_a, ["__UIScope", "onDismiss", "isDismissible", "isOpen", "children", "anchorRef", "initialFocusRef", "overlayAlignment", "verticalAlignment", "overlayClassName", "contentClassName"]);

  var rootClasses = (0, ui_helper_deep_branding_1.useEscapeClasses)({
    block: 'AnchoredOverlay',
    className: className,
    __UIScope: __UIScope
  }).rootClasses;
  var windowSize = (0, window_size_1.useWindowSize)();
  var styles = getPositionStyles(anchorRef.current, overlayAlignment, windowSize, verticalAlignment);
  var rootRef = (0, react_1.useRef)(null);
  (0, ui_helper_hooks_1.useOnClickOutside)(rootRef, function (event) {
    return onDismiss === null || onDismiss === void 0 ? void 0 : onDismiss(event);
  }, {
    isActive: isDismissible
  });
  return react_1.default.createElement(StyledDialogOverlay, {
    isOpen: isOpen,
    ref: rootRef,
    onDismiss: onDismiss,
    initialFocusRef: initialFocusRef,
    className: rootClasses
  }, react_1.default.createElement(StyledDialogContent, tslib_1.__assign({
    style: styles,
    className: contentClassName
  }, props), children));
}

exports.AnchoredOverlay = AnchoredOverlay;
var templateObject_1, templateObject_2;